import { HeadTitleContent } from '../../../commons/Constants';
import SupportPage from '../../../components/mui5/support/supportPage/SupportPage';
export default function Support(props) {
  return <SupportPage />;
}

export async function getServerSideProps(context) {
  const { query } = context;
  return {
    props: {
      extraMeta: {
        title: HeadTitleContent['support'].title,
        description: HeadTitleContent['support'].description,
      },
      option: query?.option || 'choose',
    },
  };
}
